<app-client-task-history-item-title>
  {{ title }}
</app-client-task-history-item-title>
<app-client-task-history-item-body>
  <div class="my-2 h5">{{ description }}</div>
</app-client-task-history-item-body>
